import React, { useCallback, useEffect, useState } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_FLEET_MEMBERS, TOGGLE_INDEPENDENT_WALLET } from 'actions/user';
import ReactPagination from 'components/general/ReactPagination';
import { SUPER_ADMIN } from 'components/common/constant';
import { Spinner } from 'react-bootstrap';
import { BiSort } from 'react-icons/bi';
import { Col, Row } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import SearchBox from 'components/general/SearchBox';
import Button from 'components/inputs/Button';
import { MdClear } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ToggleSwitch from 'components/inputs/ToggleSwitch';
import { toast } from 'react-toastify';
import { AiOutlineEye } from 'react-icons/ai';
import DriverTransaction from './DriverTransaction';
const MemberList = () => {
  const dispatch = useDispatch();
  const { fleetId } = useParams();
  const [searchText, setSearchText] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const { t } = useTranslation();
  const isLoader = useSelector((state) => state.fleetMember.isLoading);
  const allMember = useSelector((state) => state.fleetMember.FleetMember);
  const page = useSelector((state) => state.fleetMember.page);
  const totalData = useSelector((state) => state.fleetMember.total);
  const limit = useSelector((state) => state.fleetMember.limit);
  const totalPages = useSelector((state) => state.fleetMember.totalPages);

  const getAllUsers = useCallback(
    (data = {}) => {
      if (searchText) {
        const userData = {
          ...data,
          search: searchText,
          id: fleetId,
        };
        dispatch({
          type: FETCH_FLEET_MEMBERS.REQUEST,
          payload: userData,
        });
      } else {
        dispatch({
          type: FETCH_FLEET_MEMBERS.REQUEST,
          payload: { ...data, id: fleetId },
        });
      }
    },
    [searchText, fleetId]
  );

  const dataFilter = useCallback(() => {
    if (searchText) {
      const filterDateData = {
        search: searchText,
      };
      getAllUsers(filterDateData);
    } else {
      getAllUsers();
    }
  }, [searchText]);

  useEffect(() => {
    getAllUsers();
  }, []);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (searchText) {
        const data = {
          search: searchText,
          page: page.selected + 1,
        };
        getAllUsers(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getAllUsers(data);
      }
    },
    [sortByItem, searchText]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getAllUsers(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getAllUsers(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleReset = useCallback(() => {
    getAllUsers({});
  }, []);

  const handleSearch = () => {
    getAllUsers({});
  };

  const handleToggleIndependentWallet = useCallback(
    (memberId, currentValue) => {
      dispatch({
        type: TOGGLE_INDEPENDENT_WALLET.REQUEST,
        payload: {
          memberId,
          has_independent_wallet: !currentValue,
        },
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            toast.success(!currentValue ? 'Independent wallet enabled' : 'Independent wallet disabled');
            getAllUsers();
          }
        },
      });
    },
    [getAllUsers]
  );

  return (
    <LayoutContainer>
      <Card className="customerDetail-table">
        <div>
          <div className="customer-details-search--block" style={{ border: 'none', borderRadius: 'none' }}>
            <Row>
              <Col xl={11} md={11}>
                <SearchBox
                  preIcon={<BsSearch />}
                  postIcon={
                    <MdClear
                      onClick={() => {
                        setSearchText('');
                        handleReset();
                      }}
                    />
                  }
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                />
              </Col>
              <Col xl={'auto'} md={'auto'}>
                <div className="customerList-add-boxButton" onClick={dataFilter}>
                  <Button className="customerList-add-box-Btn">{t('button.search')}</Button>
                </div>
              </Col>
            </Row>
          </div>
          <div className="customerBooking-list-table">
            <div className="table-responsive">
              <table className="record-list-table">
                <thead>
                  <tr>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.srNo')}</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.name')}</span>
                        <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                          <BiSort size={15} />
                        </span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.email')}</span>
                        <span className="ico" onClick={() => handleSorting('email', sortByItem)}>
                          <BiSort size={15} />
                        </span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.phoneNo')}</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.vehicleName')}</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>{t('memberList.vehicleRegistrationNo')}</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>Individual Wallet</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>Wallet Balance</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting">
                        <span>Actions</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoader ? (
                    <tr>
                      <td colSpan={10} className="border-0">
                        <div className="loader-block___">
                          <Spinner as="span" animation="border" size="sm" role="status" />
                          <span className="ps-2">{t('placeHolder.loading')}</span>
                        </div>
                      </td>
                    </tr>
                  ) : _.isEmpty(allMember) ? (
                    <tr>
                      <td colSpan={5} className="border-0">
                        <div className="empty-data-block">{t('memberList.noData')}</div>
                      </td>
                    </tr>
                  ) : (
                    !(isLoader || _.isUndefined(isLoader)) &&
                    _.map(
                      _.filter(allMember, (userData) => userData.role !== SUPER_ADMIN),
                      (user, key) => {
                        const serial_num = limit * (page - 1) + key;
                        return (
                          <tr key={`user-index-${serial_num}`}>
                            <td>{serial_num + 1}</td>
                            <td>
                              {_.get(user, 'name', '')}
                              {_.get(user, 'dealer_customer.tag', 'none') !== 'none' && (
                                <span className="energy-credit-tag">{t('fleetList.landmarkTag')}</span>
                              )}
                            </td>
                            <td>{_.get(user, 'email', '')}</td>
                            <td>
                              +{_.get(user, 'country_code', '')}
                              {_.get(user, 'phone', 'NA')}
                            </td>
                            <td>
                              {_.get(user, 'vehicles').length > 0 ? `${_.get(user, 'vehicles[0].make')} (${_.get(user, 'vehicles[0].model')})` : '-'}
                            </td>
                            <td>{_.get(user, 'vehicles').length > 0 ? _.get(user, 'vehicles[0].rto_no') : '-'}</td>
                            <td>
                              <ToggleSwitch
                                checked={_.get(user, 'has_independent_wallet', false)}
                                onChange={() =>
                                  handleToggleIndependentWallet(
                                    _.get(user, 'id') || _.get(user, '_id'),
                                    _.get(user, 'has_independent_wallet', false)
                                  )
                                }
                              />
                            </td>
                            <td>
                              {_.get(user, 'has_independent_wallet')
                                ? `₹ ${_.get(user, 'wallet_balance', 0)}`
                                : '-'}
                            </td>
                            <td>
                              <span
                                title="View Transactions"
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                  setSelectedMemberId(
                                    selectedMemberId === (_.get(user, 'id') || _.get(user, '_id'))
                                      ? null
                                      : _.get(user, 'id') || _.get(user, '_id')
                                  )
                                }
                              >
                                <AiOutlineEye size={20} color={selectedMemberId === (_.get(user, 'id') || _.get(user, '_id')) ? '#3498db' : '#6c757d'} />
                              </span>
                            </td>
                          </tr>
                        );
                      }
                    )
                  )}
                </tbody>
              </table>
            </div>
            {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allMember) && (
              <ReactPagination
                currentPage={page}
                limit={limit}
                total={totalData}
                handlePageClick={(pageVal) => handlePageClick(pageVal)}
                totalPages={totalPages}
                marginPagesDisplayed={1}
              />
            )}
          </div>
        </div>
      </Card>
      {selectedMemberId && <DriverTransaction memberId={selectedMemberId} />}
    </LayoutContainer>
  );
};
export default MemberList;
